export default __webpack_public_path__ + "static/8-66cfc78c404878688026ca9f40f4a979.webp";